module.exports = __webpack_public_path__ + "img/darts.02a03f36.png";